import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26676336"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 이전 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 다음 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_terms_check_box = _resolveComponent("terms-check-box")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_footer = _resolveComponent("ag-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_header, { handle: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_modal_header, {
          title: "약관동의",
          onClose: _cache[0] || (_cache[0] = () => _ctx.setOpen(false))
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ag_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_terms_check_box, {
          onAgree: _cache[1] || (_cache[1] = (isChecked) => _ctx.nextButton = !isChecked)
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ag_footer, { pb: "safeAreaBottom" }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          px: "20px",
          py: "16px",
          dp: "flex",
          gap: "sp6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_button, {
              corner: "10px",
              outline: "primary",
              width: "100%",
              onClickCapture: _ctx.previousProcess
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["onClickCapture"]),
            _createVNode(_component_ag_button, {
              corner: "10px",
              disabled: _ctx.nextButton,
              width: "100%",
              onClickCapture: _ctx.nextProcess
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["disabled", "onClickCapture"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}